/* eslint-disable */
import buildCollectionTicketModel from "utils/collectionTicket/buildCollectionTicketModel";

// The ticket renderer is the content contract. Project only what it actually draws;
// its model also retains visit IDs, timestamps and other non-printable metadata.
export default function buildCollectionA4Model({
  visit = {},
  visitWithCollection = {},
  local = null,
  person = null,
  machines = [],
} = {}) {
  const ticket = buildCollectionTicketModel({
    visit,
    visitWithCollection,
    local,
    person,
    machines,
  });

  return {
    header: {
      localName: ticket.header.localName,
      ownerName: ticket.header.ownerName,
      dateLabel: ticket.header.dateOnlyLabel,
    },
    groups: ticket.machineGroups.map(({ type, title, machines: entries, summary }) => ({
      type,
      title: title.replace(/=/g, " ").replace(/\s+/g, " ").trim(),
      machines: entries.map(({ title: name, status, rows, valueLines, totalAmount, resetLines, noteLines }) => ({
        title: name,
        status,
        rows,
        valueLines,
        totalAmount,
        resetLines,
        noteLines,
      })),
      summary: {
        typeLabel: summary.typeLabel,
        itemCount: summary.itemCount,
        percentageMode: summary.percentageMode,
        totalAmountLabel: summary.totalAmountLabel,
        clientAmountLabel: summary.clientAmountLabel,
        ownerAmountLabel: summary.ownerAmountLabel,
        clientPercentageLabel: summary.clientPercentageLabel,
        ownerPercentageLabel: summary.ownerPercentageLabel,
      },
    })),
    generalTotals: {
      totalAmountLabel: ticket.generalTotals.totalAmountLabel,
      clientAmountLabel: ticket.generalTotals.clientAmountLabel,
      ownerAmountLabel: ticket.generalTotals.ownerAmountLabel,
    },
  };
}
